import { Formik, Form } from 'formik';
import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Input, SelectValue } from '../FormGroup';
import * as Yup from 'yup';
import Skeleton from 'react-loading-skeleton';
import { api } from '../../api/client';
// import { initESW } from '../../utils/salesforceChat';

const WebChat = ({ CurrentUser, onFormSubmitted }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [leaseContracts, setLeaseContracts] = useState([]);
    useEffect(() => {
        const loadData = async () => {
            if (!CurrentUser) return;
            setLoading(true);
            const userId = CurrentUser.userId;
            try {
                const response = await api.get('users', { params: { id: userId } });
                const responseData = response.data.Data;
                setUser(responseData);

                //let accounts = await userService.getAccounts(userId);
                //TODO: Hardcoded for testing as this feature is not implemented yet on phase 2
                let accounts = [{ value: '123456', label: 'Test 123456', name: '123456' }];
                setAccounts(accounts);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }

            setLoading(false);
        };
        loadData();
    }, [CurrentUser]);

    const FormSkeleton = () => {
        return (<div>
            {Array(7).fill().map((item, index) => <div key={`item-${index + 1}`} className="form-group" style={{ height: '60px' }}>
                <Skeleton height={45} width="100%" />
            </div>)}

            <div className="text-right"><Skeleton height={50} width="40%" /></div>
            <div style={{ height: '150px' }} />
        </div>)
    };

    const onAccountSelected = async (option) => {
        if (option && option.value) {
            //TODO: Hardcoded for testing as this feature is not implemented yet on phase 2
            //   var leases = await userService.getLeases(option.value);
            setLeaseContracts([{ value: '12345 ', label: 'Test 12345 ', name: '12345' }]);
        }

    }


    const validationSchema = Yup.object().shape({
        firstName: Yup.string().label('First Name').nullable().max(40).required(),
        lastName: Yup.string().label('Last Name').nullable().max(40).required(),
        email: Yup.string().label('Email').trim().email('Email is not valid!').max(80).required(),
        account: Yup.string().label('Account').required(),
        topic: Yup.string().label('Topic').required(),
    });

    const onSubmitHandler = (values) => {

        window.initESW(values.firstName, values.lastName, values.email, values.account, values.lease, values.caseNumber, values.topic);
        const button = document.getElementsByClassName('helpButtonEnabled')[0];
        if (button) {
            button.click();
            if (typeof onFormSubmitted === 'function') onFormSubmitted();
        }
    };



    if (!CurrentUser || !user || loading) return <FormSkeleton />;

    return (
        <>
            <Helmet>
                <script type='text/javascript' src='https://service.force.com/embeddedservice/5.0/esw.min.js'></script>
                <script type='text/javascript' src='https://devlm-timepayment.cs67.force.com/TPC/resource/Lessee_Portal_Chat_Embed'></script>
            </Helmet>
            <div>
                <h4>
                    Please complete the following form, so we can route your chat to a person who can assist you as
                    quickly as possible.
                </h4>
                <Formik
                    enableReinitialize
                    initialValues={{
                        firstName: CurrentUser.firstName,
                        lastName: CurrentUser.lastName,
                        email: user && user.Email,
                        account: '',
                        lease: '',
                        caseNumber: '',
                        topic: ''
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmitHandler}
                >
                    {({ isSubmitting, errors }) => (
                        <Form>
                            {/* <!-- pre-populate first name, last name, email address, list of account numbers and list of lease numbers from lessee portal profile --> */}
                            <Input
                                name="firstName"
                                maxLength="40"
                                required
                                placeholder='Enter first name,e.g. "John M."'
                                label="First Name:"
                            />
                            <Input
                                name="lastName"
                                maxLength="40"
                                placeholder='Enter last name,e.g. "Smith"'
                                required
                                label="Last Name:"
                            />
                            <Input name="email" maxLength="40" required label="Email address:" />
                            <SelectValue name="account" label="Account number:" options={accounts} required onChange={onAccountSelected} />
                            <SelectValue name="lease" label="Lease contract number:" options={leaseContracts} />

                            <div style={{ marginTop: '3rem', paddingBottom: '1rem' }}>
                                Are you following up on existing case? If so enter the case number.
                            </div>
                            <Input name="caseNumber" maxLength="40" label="Case number:" />

                            <Input name="topic" required={true} label="Chat Topic:" />

                            <div className="button-group button-group--right">
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    disabled={isSubmitting || Object.keys(errors).length > 0}
                                >
                                    Click here to launch hidden chat
                                </Button>

                            </div>
                            {/* <Debug /> */}
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );

}

export default WebChat;
